import { service } from "@ember/service";
import DiscourseRoute from "discourse/routes/discourse";

export default class CircleIndexRoute extends DiscourseRoute {
  @service router;

  beforeModel(transition) {
    const circleModel = this.modelFor("circle");

    const target = circleModel.can_read_topics
      ? "circle.activity"
      : "circle.about";

    if (transition.urlMethod === "replace") {
      this.router.replaceWith(target);
    } else {
      this.router.transitionTo(target);
    }
  }
}
